import { NewPassword } from "@/modules/auth/components";
import { AppPaths, Challenge } from "@/shared/common/enums";
import { Notification } from "@/shared/components";
import { useAppSelector } from "@/shared/hooks";
import { Heading } from "@ab.uitools/ui-library/components/Heading";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

export const NewPasswordPage = () => {
  const { t } = useTranslation();
  const challenge = useAppSelector((state) => state.auth.challenge);
  const navigate = useNavigate();

  useEffect(() => {
    if (challenge !== Challenge.PasswordReset) {
      navigate(AppPaths.Login);
    }
  }, []);

  return (
    <div className="auth">
      <div
        className="card flexbox flex-direction--column align-items--center full-width pt-48 pb-48 pl-48 pr-48">
        <Heading
          className="mr-12 reset-title"
          size="xsmall"
          weight="bold"
          lineHeight="small"
        >
          {t("auth.newPassword.title")}
        </Heading>
        <Notification className="mt-28 full-width"/>
        <NewPassword/>
      </div>
    </div>
  );
};
